// *** We are not allowed to use hardcoded URLs in this scenario use .env file
// the following values are available on .env file
export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const PUBLIC_BASE_URL = process.env.REACT_APP_PUBLIC_BASE_URL;
export const CLOUD_FRONT_URL = process.env.REACT_APP_CLOUD_FRONT_URL;
export const GRAPHQL_URL = process.env.REACT_APP_GRAPHQL_URL;

console.log(BASE_URL);
